// extracted by mini-css-extract-plugin
export default {"matchMode":"MedicationFilterSelect_matchMode__N1Os6"};